__webpack_require__.p = "https://daas.conviva.com/";